@if (_proposal(); as proposal) {
  @if (!skipConfirm()) {
    <div class="navigate" [class.navigate--locked]="_resolvedDecided()">
      <p class="navigate-prompt">
        {{ _w.navigateOpenPagePrompt({ bindings: { label: proposal.label } }) }}
      </p>

      <div class="navigate-actions">
        <button
          id="chat-navigate-accept"
          class="navigate-button navigate-button--accept"
          type="button"
          [disabled]="_locked"
          (click)="_onAccept()"
        >
          {{ _w.navigateOpen() }}
        </button>
        <button
          id="chat-navigate-decline"
          class="navigate-button navigate-button--decline"
          type="button"
          [disabled]="_locked"
          (click)="_onDecline()"
        >
          {{ _w.navigateStayHere() }}
        </button>
      </div>

      <label class="navigate-remember">
        <input
          #remember
          type="checkbox"
          [disabled]="_locked"
          (change)="_onToggleDontAskAgain(remember.checked)"
        />
        <span>{{ _w.navigateDontAskAgain() }}</span>
      </label>
    </div>
  }
}
